import React from 'react';

import * as S from './styles';

const Consent: React.FC = ({ children }) => {
  return <S.Container>{children}</S.Container>;
};

export default Consent;
